import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { buildHeaders, buildParams, XmStore } from 'core/services';
import { ModelBase } from 'store/model-base';
import { ApiChannel } from 'core/constants';

import { Quickpayment, QuickpaymentMdnLookup, QuickpaymentResult } from './models';
import { StoreAction } from 'store/actions';

@Injectable()
export class QuickpaymentApi {

    public static getQuickpayMdnLookup(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<QuickpaymentMdnLookup> {
        const channel: string = params.channel;
        const sessionId: string = params.sessionId;

        // Deleting channel and sessionID from params Object
        delete params.channel;
        delete params.sessionId;

        return http.get('/mdn/lookup', {
            headers: buildHeaders({
                apiChannel: ApiChannel.SSM_GATEWAY,
                channel,
                sessionId
            }),
            params: buildParams(params)
        }).pipe(
            map((response: ApiResponse) => QuickpaymentMdnLookup.create<QuickpaymentMdnLookup>({ ...response, isCpc: params.isCpc}))
        );
    }

    public static postQuickpayment(_xmStore: XmStore, http: HttpClient, payloadAndHeaders: QuickpaySubmitPayloadAndHeaders): Observable<QuickpaymentResult> {
        const channel: string = payloadAndHeaders.headers.channel;
        const sessionId: string = payloadAndHeaders.headers.sessionId;
        const apiChannel: ApiChannel = ApiChannel.SSM_GATEWAY;

        return http.post('/account/quickpayment', payloadAndHeaders.payload, {
            headers: buildHeaders({
                apiChannel,
                channel,
                sessionId
            })
        }).pipe(
            map((response: QuickpaymentResult) => QuickpaymentResult.create<QuickpaymentResult>(response))
        );
    }

    public static saveQuickpayment(_xmStore: XmStore, _http: HttpClient, payload: object): Observable<Quickpayment> {
        return of(Quickpayment.create<Quickpayment>(payload));
    }

    public static getQuickpayment(_xmStore: XmStore, _http: HttpClient, quickPaymentDetails: Quickpayment): Observable<Quickpayment> {
        return of(quickPaymentDetails);
    }
}

ModelBase.persistMapping[StoreAction.POST_QUICKPAYMENT] = QuickpaymentApi.postQuickpayment;
ModelBase.fetchMapping[StoreAction.GET_QUICKPAYMENT_MDN_LOOKUP] = QuickpaymentApi.getQuickpayMdnLookup;
ModelBase.persistMapping[StoreAction.SAVE_QUICKPAYMENT_DATA] = QuickpaymentApi.saveQuickpayment;
ModelBase.fetchMapping[StoreAction.GET_QUICKPAYMENT_DATA] = QuickpaymentApi.getQuickpayment;
